module.exports = __webpack_public_path__ + "static/team-img5-6ea95739f288661a28a85e857d914dc0.jpg";